<template>
    <div name="center-register">
        <loading v-if="isLoading" />
        <div class="header">
            <span class="center-name">{{centerName}}</span>
            <span class="title">환자 정보를 입력해 주세요</span>
            <span class="sub-title">간편한 비대면진료를 위한 한 번의 환자 등록!<br/> <span style="color: #000">진료 받으실 분의 정보</span>를 등록해 주세요</span>
        </div>
        <div class="contain">
            <div>
                <text-label 
                    :text="'이름(진료 받으실 분)'"
                    :isDefault="true"
                />
                <input v-model="profile_specify.name" 
                    v-focus-background
                    style="background-color: var(--Gray-20, #F3F5F8)"
                    ref="name"
                    class="input-big"
                    placeholder="이름을 적어주세요"
                />
            </div>
            <div style="margin-top: 20px;">
                <text-label 
                    :text="'주민등록번호'"
                    :isDefault="true"
                />
                <div style="margin-bottom: 8px;display: flex;align-items: center;">
                    <input v-model="registrationNumber1" inputmode="numeric" 
                        v-focus-background
                        class="input-medium"
                        placeholder="주민번호 앞자리"
                        maxlength="6"
                        ref="registrationNumber1"
                    /> <span style="margin-right: 7px;">-</span> 
                    <input type="password" v-model="registrationNumber2" inputmode="numeric" 
                        v-focus-background
                        class="input-medium"
                        placeholder="주민번호 뒷자리"
                        maxlength="7"
                        ref="registrationNumber2"
                    />
                </div>    
                <div class="row">
                    <span class="info-text">병원에서 <span class="info-color-text">진료와 처방전 발행</span>에 필요해요</span>
                </div>       

            </div>
        </div>
        <div class="agree-box">
            <span class="agree-title">약관에 동의해 주세요<span style="color: var(--Semantic-01_Red, #FF000F);">*</span></span>
            <div class="all-agree" ref="agree" style="margin-top: 30px;">
                <check-box 
                    :checked="allAgree"
                    @onClick="allAgreeFunction"
                />
                <span @click="allAgreeFunction" class="all-agree-text">모두 동의합니다.</span>
            </div>
            <div v-if="agreeError" class="error-info-text">이용약관에 동의해 주세요</div>

            <div class="agree-detail-box" style="margin-top: 20px;">
                <div class="row">
                    <check-box 
                        :checked="agreement_terms_condition_description"
                        @onClick="() => {agreement_terms_condition_description = !agreement_terms_condition_description}"
                    />
                    <span class="agree-text"><span style="color: var(--point-color3, #FF000F)">(필수)</span> 서비스 이용약관</span>
                </div>

                <img style="width: 20px;cursor: pointer;" @click="openPolicy(1)" src="../../assets/detail.png" />
            </div>
            <div class="agree-detail-box" style="margin-top: 16px;margin-bottom: 40px">
                <div class="row">
                    <check-box 
                        :checked="agreement_personal_info"
                        @onClick="() => {agreement_personal_info = !agreement_personal_info}"
                    />
                    <span class="agree-text"><span style="color: var(--point-color3, #FF000F)">(필수)</span> 개인정보 수집 및 이용 제공 동의</span>
                </div>
                <img style="width: 20px;cursor: pointer;" @click="openPolicy(2)" src="../../assets/detail.png" />
            </div>
         
            <bottom-button 
                :text="'제출하기'"
                :color="'var(--Gray-100, #1E1E1E)'"
                @onClick="submit"
            />
        </div>
    </div>
</template>

<script>
import Constant from '@/constant';
import {mapState} from 'vuex';
import CheckBox from '@/components/atoms/CheckBox';
import Convert from '@/utilities/convert';
import focusBackground from '@/components/directives/focusBackground';
import BottomButton from '@/components/atoms/BottomButton';
import TextLabel from '@/components/atoms/TextLabel';
import Loading from '@/components/molecules/Loading'


export default {
    name: 'centerRegister',
    components: {
        BottomButton,
        CheckBox,
        TextLabel,
        Loading
    },
    data: function()
    {
        return {
            registrationNumber1: '',
            registrationNumber2: '',
            allAgree: false,
            agreeError: false,
            agreement_location_service: false,
            agreement_marketing: false,
            agreement_personal_info: false,
            agreement_terms_condition_description: false,
            isLoading: false,
            centerName: ''
        }
    }, 
    directives: {
        focusBackground
    },
    computed: mapState(['profile_specify', 'agreements']),
    props: ['centerId', 'groupId'],
    mounted: function()
    {   
        this.topFunction();
        this.$store.dispatch(Constant.FETCH_BAROCARE_NAME, {uuid: this.centerId})
            .then((res) => {
                this.centerName = res.name;
            })
            .catch((err) => {

            })
    },
    methods: {
        submit: function()
        {

            if(this.profile_specify.name == '' || Convert.containsNumber(this.profile_specify.name))
            {
                this.errorFocus('name');
                return;
            }
            if(this.registrationNumber1.length !== 6)
            {
                this.errorFocus('registrationNumber1')
                return;
            }

            if(this.registrationNumber2.length !== 7)
            {
                this.errorFocus('registrationNumber2')
                return;
            }
            if(!this.agreement_terms_condition_description || !this.agreement_personal_info || !this.agreement_location_service)
            {
                this.agreeError = true;
                return;
            }

            this.agreements.agreement_location_service = this.agreement_location_service;
            this.agreements.agreement_marketing = this.agreement_marketing;
            this.agreements.agreement_personal_info = this.agreement_personal_info;
            this.agreements.agreement_terms_condition_description = this.agreement_terms_condition_description;
            this.profile_specify.registration_number = this.registrationNumber1 + this.registrationNumber2;

            this.isLoading = true;
            this.$store.dispatch(Constant.REGISTER_BAROCARE_USER_SPECIFY, {uuid: this.centerId, groupId: this.groupId})
                .then(() => {
                    // api call, card error 
                    this.registrationNumber1 = '';
                    this.registrationNumber2 = '';
                    this.allAgree = false;
                    this.isLoading = false;
                    this.$emit('onComplete')
                })
                .catch((error) => {
                    if(error.code.includes('PAYMENT'))
                    {
                        this.isLoading = false;
                        this.$emit('onError', error.title, error.message);
                    }
                    else
                    {
                        this.isLoading = false;
                        this.$emit('onError', error.title, error.message);
                    }
                    
                })
        },  
        topFunction: function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 
        moveToNext: function(event, nextField) {
            if (event.target.value.length === 6) {
                // this.$refs['registrationNumber1'].style.backgroundColor = 'var(--Gray-20, #F3F5F8)';
                this.$refs[nextField].focus();
            }
        },
        allAgreeFunction: function()
        {
            this.allAgree = !this.allAgree;
        },
        errorFocus: function(field)
        {
            this.$refs[field].style.border = '1.5px solid var(--Semantic-01_Red, #FF000F)';

            const offsetTop = this.$refs[field].offsetTop;
                window.scrollTo({
                    top: offsetTop - 50, // 50px 위로 조정
                    behavior: 'smooth'
            });
        },
        openPolicy: function(index)
        {   
            if(index === 1)
            {
                window.open("https://policy.soldoc.co.kr/barocare/terms", '_blank')
            }
            else if(index === 2)
            {
                window.open("https://policy.soldoc.co.kr/barocare/use", '_blank')
            }
        }
    },
    watch: {
        allAgree: function()
        {
            this.agreement_location_service = this.allAgree;
            this.agreement_marketing = this.allAgree;
            this.agreement_personal_info = this.allAgree;
            this.agreement_terms_condition_description = this.allAgree;
            this.agreeError = false;
        },
        registrationNumber1: function(newValue) {
            this.registrationNumber1 = newValue.replace(/[^0-9]/g, '');

        },
        registrationNumber2(newValue) {
            this.registrationNumber2 = newValue.replace(/[^0-9]/g, '');
        },
        agreement_terms_condition_description: function()
        {
            this.agreeError = false;
        },
        agreement_personal_info: function()
        {
            this.agreeError = false;
        },
        agreement_location_service: function()
        {
            this.agreeError = false;
        }
    }
}
</script>

<style scoped>
    .contain {
        width: 100%;
        padding: 40px 16px;
        display: flex;
        flex-direction: column;
    }
    .header {
        width: calc(100% - 32px);
        padding: 24px 16px;
        background: #F3F5F8;
        display: flex;
        flex-direction: column;
    }
    .center-name {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px; /* 108.333% */
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px; /* 108.333% */
        margin-top: 55px;
    }
    .sub-title {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-top: 16px;
    }
    .input-big {
        width: calc(100% - 64px);
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
    }
    input::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }
    .input-medium {
        width: calc(50% - 32px - 30px);
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        margin-right: 7px;
    }
    .info-text {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 111.111% */
    }
    .info-color-text {
        color: #184FA1;
    }
    .agree-box {
        border-top: 8px solid var(--Gray-sub-color1, #F3F5F8);
        padding: 40px 16px 0 16px;
        width: calc(100% - 32px);
    }
    .all-agree {
        height: 60px;
        flex-shrink: 0;
        width: calc(100% - 16px);
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        padding-left: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
    }
    .agree-detail-box {
        padding-left: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 32px;
        width: calc(100% - 16px);

    }

    .all-agree-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 100% */
        cursor: pointer;
        margin-left: 17px;
    }
    .agree-text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        margin-left: 17px;
    }
    .error-info-text {
        color: var(--Semantic-01_Red, #FF000F);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-top: 8px;
    }
    .row {
        display: flex;
    }
    .agree-title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px; /* 108.333% */
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/CenterRegister.vue